module.exports = __webpack_public_path__ + "static/img/li.fb5437d3.svg";